import React, { useState, useRef, useEffect } from "react";
import { Modal, Select, Input, notification, Spin } from "antd";
import CustomButton from "../../../../../utility/CustomButton";
import { findUsersBasic } from "../../../../../app/modules/User/_redux/users/usersCrud";
import { getUserByToken, login, loginWithPin } from "../../../../../app/modules/Auth/_redux/authCrud";
import { handleApiErrorResponse } from "../../../../../app/modules/Common/utils";
import { useDispatch } from "react-redux";
import { actions } from "../../../../../app/modules/Auth/_redux/authRedux";
import { UserSwitchOutlined } from "@ant-design/icons";
import { debounce } from "lodash";


const SwitchUser = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading,setLoading]=useState(false);
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const dispatch = useDispatch()

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedUser(null);
    setPin(["", "", "", "", "", ""]);
  };

  const handleInputChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);

      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "Enter" && pin.join("").length === 6) {
      handleSwitch();
    }
  };
  

  const getUsers = (params) => {
    findUsersBasic({...params, page_size: -1 })
      .then((response) => {
        setUsers(response.data.entities);
      })
      .catch((err) => {
        handleApiErrorResponse(err)
      });
  };

  const handleSearch = debounce((value) => {
    getUsers({ search_key: value });
  }, 500);
  
  useEffect(() => {
    getUsers({ search_key: "" });
  }, []);


const handleSwitch = async () => {
    const finalPin = pin.join("");
  
    if (!selectedUser || finalPin.length !== 6) {
      notification.error({ message: "Please select a user and enter a 6-digit PIN." });
      return;
    }
  
    try {
      setLoading(true);
      const response = await loginWithPin(selectedUser, finalPin);
  
      const { access_token, refresh_token } = response?.entity || {};
  
      if (access_token && refresh_token) {
        // ✅ Dispatch Redux first
        dispatch(actions.login(access_token, refresh_token, null));
  
        // ✅ Then update localStorage to avoid race conditions
        localStorage.setItem("access_token", access_token);
  
        // ✅ Fetch new user details smoothly
        const userResponse = await getUserByToken();
        console.log("userResponse", userResponse);
        handleCancel();
  
        if (userResponse?.data?.entity) {
          dispatch(actions.fulfillUser(userResponse.data.entity));
          setTimeout(() => {
            window.location.reload();
          }, 500);
          window.location.href = "/catalog/products";
        }
      }
    } catch (error) {
      console.error("Switch Error:", error);
      notification.error({ message: error.message || "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };
  
  return (
      <div>
      <UserSwitchOutlined className="switch-user-icon" onClick={showModal} />
      <Modal
        title="Switch User"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        className="switch-user-modal"
        destroyOnClose={true}
        maskStyle={{ backdropFilter: "blur(8px)", background: "rgba(0, 0, 0, 0.2)" }}
      >
        <span>Select User</span>
        <Select
         className="switch-user-dropdown mt-1" 
         placeholder="Select User" 
         showArrow
         showSearch
         optionFilterProp="label"
         filterOption={false}
         onSearch={handleSearch}
         options={users.map((user) => ({
           key: user.id,
           value: user.username,
           label: user?.username || `${user.first_name} ${user.last_name}`,
         }))}
         onChange={(value) => {
            setSelectedUser(value);
            setPin(["", "", "", "", "", ""]);
          }}
        />
        <div className="mt-4">
          <span>Pin</span>
          <div style={{ display: "flex", justifyContent: "center", gap: "18px" }}>
            {pin.map((num, index) => (
              <Input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleInputChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                maxLength={1}
                type="text"
                value={num ? "*" : ""}
                style={{
                  width: "75px",
                  height: "35px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontSize: "18px",
                }}
              />
            ))}
          </div>
        </div>
        <hr/>
        <div className="d-flex justify-content-end mt-6" style={{ gap: "8px" }}>
          <CustomButton label="Cancel" className="picklist-modal-no-btn" onClick={handleCancel} />
          <Spin spinning={loading}>
          <CustomButton label="Switch" className="picklist-modal-ok-btn" onClick={handleSwitch} />
          </Spin>
        </div>
      </Modal>
    </div>
  );
};

export default SwitchUser;
